import React from "react";
import { Link } from "react-router-dom";
import { useLiveEdit } from "../../lib/liveEdit";
import { Pencil, Eye, ExternalLink, Sparkles } from "lucide-react";

export default function EditModeBar() {
  const { isAdmin, editMode, setEditMode } = useLiveEdit();
  if (!isAdmin) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[80] flex items-center gap-1 bg-[#04102e] text-white rounded-full pl-4 pr-2 py-2 shadow-2xl border border-yellow-400/40 backdrop-blur"
      data-testid="live-edit-bar"
    >
      <div className="flex items-center gap-2 pr-3 border-r border-white/10">
        <div className={`h-2 w-2 rounded-full ${editMode ? "bg-yellow-400 animate-pulse" : "bg-slate-500"}`} />
        <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-yellow-300">
          {editMode ? "Editing" : "Live Edit"}
        </span>
      </div>
      <button
        onClick={() => setEditMode(!editMode)}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold transition ${
          editMode
            ? "bg-yellow-400 text-[#0B2A6B] hover:bg-yellow-300"
            : "bg-white/10 text-white hover:bg-white/20"
        }`}
        data-testid="live-edit-toggle-btn"
      >
        {editMode ? (
          <>
            <Eye className="h-3.5 w-3.5" /> Preview
          </>
        ) : (
          <>
            <Pencil className="h-3.5 w-3.5" /> Edit page
          </>
        )}
      </button>
      <Link
        to="/admin"
        className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-bold bg-white/10 hover:bg-white/20"
        data-testid="live-edit-admin-link"
      >
        <ExternalLink className="h-3.5 w-3.5" /> Admin
      </Link>
      {editMode && (
        <div className="hidden md:flex items-center gap-1 pl-3 border-l border-white/10 text-[10px] text-slate-300">
          <Sparkles className="h-3 w-3 text-yellow-400" />
          Click any text or image to edit
        </div>
      )}
    </div>
  );
}
